import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import './Reviews.css';

const testimonials = [
    {
        id: 1,
        name: 'Ajinkya Patil',
        review: 'Excellent service and competitive pricing. Highly recommended for quality products in Chattrapati Sambhajinagar.',
        stars: 5,
        yearsAgo: '1 year ago'
    },
    {
        id: 2,
        name: 'Pawan Deshmukh',
        review: 'Great variety of products available with prompt delivery in Chattrapati Sambhajinagar. Fantastic experience!',
        stars: 5,
        yearsAgo: '6 months ago'
    },
    {
        id: 3,
        name: 'Swapnil Jadhav',
        review: 'Top-notch videojet ink suppliers in Chattrapati Sambhajinagar with reliable service and quality.',
        stars: 5,
        yearsAgo: '1 year ago'
    },
    {
        id: 4,
        name: 'Vaibhav Shinde',
        review: 'Reliable videojet ink dealers in Chattrapati Sambhajinagar. Very satisfied with the overall service.',
        stars: 5,
        yearsAgo: '2 months ago'
    },
    {
        id: 5,
        name: 'Rajesh Kulkarni',
        review: 'Trusted videojet ink dealers in Chattrapati Sambhajinagar. Excellent customer service and product quality.',
        stars: 5,
        yearsAgo: '2 years ago'
    },
    {
        id: 6,
        name: 'Sandeep Khandekar',
        review: 'One of the best videojet ink suppliers in Chattrapati Sambhajinagar. Timely service and good pricing.',
        stars: 5,
        yearsAgo: '2 years ago'
    }
];


const getInitials = (name) => {
    return name.charAt(0).toUpperCase();
};

const Reviews = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,      
        autoplaySpeed: 3000,  
    };

    return (
        <div className="carousel-container">
            <h2>WHAT OUR <span>CLIENTS SAY</span></h2>
            <div className="underline"></div>
            <Slider {...settings}>
                {testimonials.map((testimonial) => (
                    <div className="testimonial-card" key={testimonial.id}>
                        <div className="testimonial-image" style={{ backgroundColor: getRandomColor() }}>
                            {getInitials(testimonial.name)}
                        </div>
                        <h3>{testimonial.name}</h3>
                        <div className="stars">
                            {'★'.repeat(testimonial.stars)}
                        </div>
                        <p>{testimonial.review}</p>
                        <div className="years-ago">{testimonial.yearsAgo}</div>
                        <FontAwesomeIcon icon={faGoogle} className="google-logo" />
                    </div>
                ))}
            </Slider>
            <a href="https://www.google.com/search?q=your+business+name&rlz=1C1GCEV_enIN824IN824&oq=your+business+name&aqs=chrome.0.69i59j0i390l6j69i60.2008j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bc2e930fe2b4c0b:0xf13d7f0a00138f51,1,,,," target="_blank" rel="noopener noreferrer">
                <button className="review-button">
                    Review Us on Google
                </button>
            </a>
        </div>
    );
};

const getRandomColor = () => {
    const colors = ['#FF5733', '#3357FF', '#FF33A5', '#FF8C33','#FF3357'];
    return colors[Math.floor(Math.random() * colors.length)];
};

export default Reviews;
